/* eslint-disable eqeqeq */
/* eslint-disable react/sort-comp */
/* eslint-disable no-return-assign */
import { Component } from 'preact';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import IMask from 'imask';

import getUTM from '%/utils/utm';
import CustomSelect from '../../CustomSelect';
import UsedModelBoxInfo from '../UsedModelBoxInfo';
import { priceMask, kmMask } from '../../../utils/masks';
import fipeServiceApi from '../../../utils/fipeServiceApi';

import {
  setUsedModelValue,
  setUsedModelInformations,
} from '../../../stores/FinancingSimulator';
import RangeInput from '../../RangeInput';
import { addCurrencyDots } from '../utils';

export default class UsedModelEvaluation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      brands: [],
      models: [],
      modelYears: [],
      usedModelBrand: '',
      usedModelName: '',
      usedModelYear: '',
      usedModelAveragePrice: '',
      usedModelKM: '',
      usedModelFipeCode: '',
      usedModelSaleValue: '',
      usedModelBrandIsValid: true,
      usedModelNameIsValid: true,
      usedModelYearIsValid: true,
      usedModelKMIsValid: true,
      usedModelSaleValueIsValid: true,
    };

    this.handleUsedModelBrandChange =
      this.handleUsedModelBrandChange.bind(this);
    this.handleUsedModelNameChange = this.handleUsedModelNameChange.bind(this);
    this.handleUsedModelYearChange = this.handleUsedModelYearChange.bind(this);
    this.handleUsedModelKMChange = this.handleUsedModelKMChange.bind(this);
    this.handleUsedModelSaleValue = this.handleUsedModelSaleValue.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.saveUsedModelInformation = this.saveUsedModelInformation.bind(this);
    this.addCurrencyFormat = this.addCurrencyFormat.bind(this);
    this.removeCurrencyFormat = this.removeCurrencyFormat.bind(this);

    window.store.FinancingSimulator.watch(setUsedModelValue, store => {
      this.setState({
        usedModelSaleValue: store.usedModelValue,
      });
    });
  }

  addCurrencyFormat(value) {
    const currencyValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `R$ ${currencyValue}`;
  }

  removeCurrencyFormat(value) {
    return value.replace(/R\$ |\./g, '');
  }

  convertValueToNumber(value) {
    return parseFloat(this.removeCurrencyFormat(value).replace(',', '.'));
  }

  componentDidMount() {
    fipeServiceApi.getBrands().then(brands => this.setState({ brands }));

    IMask(this.usedModelKMInput, { mask: kmMask });
    IMask(this.usedModelSaleValueInput, priceMask);
  }

  handleUsedModelBrandChange(e) {
    const { value: brandId } = e.target;

    if (!brandId) return;

    fipeServiceApi.getModels(brandId).then(models => {
      this.setState({
        models,
        usedModelBrand: brandId,
        usedModelBrandIsValid: true,
        usedModelName: '',
        usedModelYear: '',
        usedModelAveragePrice: '',
      });
    });
  }

  handleUsedModelNameChange(e) {
    const { value: modelId } = e.target;

    if (!modelId) return;

    fipeServiceApi
      .getModelYears(this.state.usedModelBrand, modelId)
      .then(modelYears => {
        this.setState({
          modelYears,
          usedModelName: modelId,
          usedModelNameIsValid: true,
          usedModelYear: '',
          usedModelAveragePrice: '',
        });
      });
  }

  handleUsedModelYearChange(e) {
    const { value: modelYear } = e.target;

    if (!modelYear) return;

    fipeServiceApi
      .getPrice(this.state.usedModelBrand, this.state.usedModelName, modelYear)
      .then(data => {
        this.setState({
          usedModelYear: modelYear,
          usedModelYearIsValid: true,
          usedModelAveragePrice: data.price,
          usedModelFipeCode: data.fipeCode,
        });
      });
  }

  handleUsedModelKMChange(e) {
    const { value } = e.target;

    this.setState({
      usedModelKM: value,
      usedModelKMIsValid: true,
    });
  }

  handleUsedModelSaleValue(value) {
    const { usedModelAveragePrice } = this.state;
    const maxValueUsedModel = this.convertValueToNumber(usedModelAveragePrice);
    const numberValue = this.convertValueToNumber(value);

    const valueFormatted =
      numberValue > maxValueUsedModel
        ? addCurrencyDots(maxValueUsedModel.toString())
        : value.replace('R$ ', '');

    this.setState({
      usedModelSaleValue: valueFormatted,
      usedModelSaleValueIsValid: true,
    });

    setUsedModelValue(valueFormatted);
  }

  getUsedModelBrandLabel() {
    const found = this.state.brands.find(
      brand => brand.value == this.state.usedModelBrand,
    );

    return (found && found.label) || '';
  }

  getUsedModelNameLabel() {
    const found = this.state.models.find(
      model => model.value == this.state.usedModelName,
    );

    return (found && found.label) || '';
  }

  getUsedModelYearLabel() {
    const found = this.state.modelYears.find(
      modelYear => modelYear.value == this.state.usedModelYear,
    );

    return (found && found.label) || '';
  }

  saveUsedModelInformation() {
    const { usedModelKM, usedModelFipeCode } = this.state;

    const usedModelInformation = {
      usedModelBrand: this.getUsedModelBrandLabel(),
      usedModelName: this.getUsedModelNameLabel(),
      usedModelYear: this.getUsedModelYearLabel(),
      usedModelKM,
      usedModelFipeCode,
    };

    setUsedModelInformations(usedModelInformation);
  }

  handleNextStep(e) {
    e.preventDefault();

    this.saveUsedModelInformation();

    const formElements = [
      {
        element: this.usedModelBrandInput,
        stateKey: 'usedModelBrandIsValid',
      },
      {
        element: this.usedModelNameInput,
        stateKey: 'usedModelNameIsValid',
      },
      {
        element: this.usedModelYearInput,
        stateKey: 'usedModelYearIsValid',
      },
      {
        element: this.usedModelKMInput,
        stateKey: 'usedModelKMIsValid',
      },
      {
        element: this.usedModelSaleValueInput,
        stateKey: 'usedModelSaleValueIsValid',
      },
    ];

    const formIsValid = formElements.reduce(
      (accumulator, { element, stateKey }) => {
        const value = String(
          element.selectElement ? element.selectElement.value : element.value,
        ).trim();

        if (value == '' || value == 'R$') {
          this.setState({ [stateKey]: false });

          return accumulator && false;
        }

        this.setState({ [stateKey]: true });

        return accumulator && true;
      },
      true,
    );

    if (!formIsValid) {
      e.stopImmediatePropagation();
      return;
    }

    this.sendConversion();
  }

  sendConversion() {
    const params = this.getConversionParams();

    // eslint-disable-next-line no-undef
    return serviceConversion
      .convert(params)
      .then(() => {})
      .catch(error => {
        console.error(error);
      });
  }

  getConversionParams() {
    const {
      model,
      version,
      unit,
      modelValue,
      username: name,
      phone,
      cpf,
      email,
      mailing,
      phoning,
      whatsapping,
      usedOnChange,
      usedModelBrand,
      usedModelName,
      usedModelYear,
      productId,
    } = window.store.FinancingSimulator.getState();

    return {
      bait: '-7',
      paymentMethod: 'Quero financiar',
      SubOrigem__c: 'DDM Financiamento',
      category: this.props.category,
      utmz: getUTM(),
      brand: this.props.brand,
      channel: this.props.channel,
      unit,
      product_id: productId,
      product: model,
      version,
      modelValue,
      cpf,
      email,
      name,
      mailing,
      phone,
      phoning,
      whatsapping,
      usedOnChange,
      usedModelBrand,
      usedModelName,
      usedModelYear,
      usedModelAveragePrice: this.state.usedModelAveragePrice,
      usedModelKM: this.state.usedModelKM,
      usedModelFipeCode: this.state.usedModelFipeCode,
      usedModelSaleValue: this.state.usedModelSaleValue,
    };
  }

  render() {
    const { formId } = this.props;

    const {
      brands,
      models,
      modelYears,
      usedModelBrand,
      usedModelName,
      usedModelYear,
      usedModelAveragePrice,
      usedModelKM,
      usedModelSaleValue,
      usedModelBrandIsValid,
      usedModelNameIsValid,
      usedModelYearIsValid,
      usedModelKMIsValid,
      usedModelSaleValueIsValid,
    } = this.state;

    const rangeInputValue = Number(
      this.removeCurrencyFormat(usedModelSaleValue),
    );

    const rangeInputMax = this.convertValueToNumber(usedModelAveragePrice);

    return (
      <div className="used-model-evaluation">
        <h2 className="step__title">Avaliação de Seminovo</h2>

        {/* eslint-disable-next-line react/no-unused-class-component-methods */}
        <form id={formId} ref={form => (this.form = form)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 d-flex flex-column justify-content-between">
              <div className="form-group">
                <label className="bold-label" htmlFor="used-model-bran">
                  Marca do seu Seminovo
                </label>
                <CustomSelect
                  handleSelectChange={this.handleUsedModelBrandChange}
                  name="used-model-brand"
                  options={brands}
                  value={usedModelBrand}
                  placeholderValue="Selecione a marca"
                  searchEnabled
                  ref={usedModelBrandInput =>
                    (this.usedModelBrandInput = usedModelBrandInput)
                  }
                />

                {!usedModelBrandIsValid && (
                  <div
                    id="invalid-used-model-brand"
                    className="invalid-feedback is-invalid-used-model-brand"
                  >
                    <div
                      className="error-message"
                      id="bouncer-error_used-model-brand"
                    >
                      Por favor, selecione esse campo
                    </div>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label className="bold-label" htmlFor="used-model-name">
                  Modelo do seu Seminovo
                </label>
                <CustomSelect
                  handleSelectChange={this.handleUsedModelNameChange}
                  name="used-model-name"
                  options={models}
                  value={usedModelName}
                  placeholderValue="Selecione o modelo"
                  searchEnabled
                  ref={usedModelNameInput =>
                    (this.usedModelNameInput = usedModelNameInput)
                  }
                />

                {!usedModelNameIsValid && (
                  <div
                    id="invalid-used-model-name"
                    className="invalid-feedback is-invalid-used-model-name"
                  >
                    <div
                      className="error-message"
                      id="bouncer-error_used-model-name"
                    >
                      Por favor, selecione esse campo
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="bold-label" htmlFor="used-model-year">
                      Ano do modelo
                    </label>
                    <CustomSelect
                      handleSelectChange={this.handleUsedModelYearChange}
                      name="used-model-year"
                      options={modelYears}
                      value={usedModelYear}
                      placeholderValue="Selecione o ano"
                      searchEnabled
                      ref={usedModelYearInput =>
                        (this.usedModelYearInput = usedModelYearInput)
                      }
                    />

                    {!usedModelYearIsValid && (
                      <div
                        id="invalid-used-model-year"
                        className="invalid-feedback is-invalid-used-model-year"
                      >
                        <div
                          className="error-message"
                          id="bouncer-error_used-model-year"
                        >
                          Por favor, selecione esse campo
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="bold-label" htmlFor="used-model-km">
                      Quilometragem
                    </label>
                    <input
                      onChange={this.handleUsedModelKMChange}
                      value={usedModelKM}
                      type="text"
                      className="form-control"
                      name="used-model-km"
                      required
                      placeholder="KM"
                      data-bouncer-target="#invalid-used-model-km"
                      ref={usedModelKMInput =>
                        (this.usedModelKMInput = usedModelKMInput)
                      }
                    />

                    {!usedModelKMIsValid && (
                      <div
                        id="invalid-used-model-km"
                        className="invalid-feedback is-invalid-used-model-km"
                      >
                        <div
                          className="error-message"
                          id="bouncer-error_used-model-km"
                        >
                          Por favor, informe esse campo
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 used-model-evaluation__second-column">
              <UsedModelBoxInfo
                brand={this.getUsedModelBrandLabel()}
                model={this.getUsedModelNameLabel()}
                yearModel={this.getUsedModelYearLabel()}
                value={usedModelAveragePrice}
              />

              <div className="form-group">
                <label className="bold-label" htmlFor="used-model-sale-value">
                  Por quanto deseja vender seu seminovo?
                </label>

                <RangeInput
                  value={rangeInputValue}
                  max={rangeInputMax}
                  onInput={({ target }) =>
                    this.handleUsedModelSaleValue(target.value)
                  }
                  onChange={({ target }) =>
                    this.handleUsedModelSaleValue(
                      this.addCurrencyFormat(target.value),
                    )
                  }
                  disabled={!usedModelAveragePrice}
                />
                <div className="range-input__bottom-price-range">
                  <div>R$ 0,00</div>
                  <div>
                    {this.getUsedModelYearLabel()
                      ? this.addCurrencyFormat(rangeInputMax.toString())
                      : 'R$ -'}
                  </div>
                </div>

                <input
                  onChange={({ target }) =>
                    this.handleUsedModelSaleValue(target.value)
                  }
                  value={
                    usedModelSaleValue
                      ? `R$ ${usedModelSaleValue}`
                      : usedModelSaleValue
                  }
                  max={rangeInputMax}
                  type="text"
                  className="form-control"
                  name="used-model-sale-value"
                  required
                  placeholder="R$"
                  data-bouncer-target="#invalid-used-model-sale-value"
                  ref={usedModelSaleValueInput =>
                    (this.usedModelSaleValueInput = usedModelSaleValueInput)
                  }
                  disabled={!usedModelAveragePrice}
                />

                {!usedModelSaleValueIsValid && (
                  <div
                    id="invalid-used-model-sale-value"
                    className="invalid-feedback is-invalid-used-model-sale-value"
                  >
                    <div
                      className="error-message"
                      id="bouncer-error_used-model-sale-value"
                    >
                      Por favor, informe esse campo
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>

        <div className="btns-group">
          <button
            type="button"
            className="btn btn-prev btn-prev--outline font-weight-bold"
          >
            Anterior
          </button>
          <button
            type="button"
            className="btn btn-next button--primary font-weight-bold"
            onClick={this.handleNextStep}
          >
            Próximo
          </button>
        </div>
      </div>
    );
  }
}

UsedModelEvaluation.defaultProps = {
  formId: '',
  category: '',
  brand: '',
  channel: '',
};

UsedModelEvaluation.propTypes = {
  formId: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  channel: PropTypes.string,
};
